import { render, staticRenderFns } from "./AxisSkeleton.vue?vue&type=template&id=cfaec15e&"
import script from "./AxisSkeleton.vue?vue&type=script&lang=js&"
export * from "./AxisSkeleton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports